import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LangSwitch from "@/components/LangSwitch";

export default function Header({ minimal = false }) {
  const { t } = useTranslation();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-white/80 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <a
            href="https://ariovis.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-logo-link"
            aria-label={t("header.logo_alt")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/logos/Logotype_BLACK.svg`}
              alt="Ariovis"
              className="h-7 w-auto"
              data-testid="header-logo"
            />
          </a>
          <span className="hidden md:inline-block h-5 w-px bg-slate-300" />
          <Link
            to="/"
            className="hidden md:inline-block text-[11px] tracking-[0.18em] text-slate-500 font-medium uppercase hover:text-slate-900 transition"
            data-testid="header-product-label"
          >
            {t("header.product_label")}
          </Link>
        </div>
        <nav className="flex items-center gap-3 sm:gap-5 text-sm text-slate-600">
          <a
            href="https://ariovis.fr/produits"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-products"
            className="hidden sm:inline hover:text-slate-900 transition"
          >
            {t("header.nav_products")}
          </a>
          <a
            href="https://ariovis.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-ariovis"
            className="hidden sm:inline hover:text-slate-900 transition"
          >
            ariovis.fr
          </a>
          <LangSwitch />
        </nav>
      </div>
    </header>
  );
}
